export function initJumpmarks(offset = 0, query = document.querySelectorAll('a[href^="#"]')) {
    for (const jumpmark of query) {
        jumpmark.addEventListener("click", function (e) {
            e.preventDefault();
            if (jumpmark.closest(".modal")) {
                return;
            }
            // Resolve lazily instead of once at init time: a sticky header's height
            // can change after the page has loaded (e.g. late webfont swap, layout
            // shifts), so a value captured once at load can go stale.
            const resolvedOffset = typeof offset === "function" ? offset() : offset;
            const href = jumpmark.getAttribute("href");
            if (href) {
                if (href === "#") {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                } else {
                    const target = document.getElementById(href.replace("#", ""));
                    if (target) {
                        const top = window.scrollY + target.getBoundingClientRect().top;
                        window.scrollTo({
                            top: top - resolvedOffset,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                }
            }
        });
    }
}